import { create } from 'zustand';
import { AppPavilionDataMap } from '../utils/getStandsDataMap';

interface ActiveRoomState {
    activeRoom: AppPavilionDataMap | null;
    setActiveRoom: (room: AppPavilionDataMap | null) => void;
    clearActiveRoom: () => void;
}

export const useActiveRoomStore = create<ActiveRoomState>((set) => ({
    activeRoom: null,
    setActiveRoom: (room) => set({ activeRoom: room }),
    clearActiveRoom: () => set({ activeRoom: null }),
}));
